<template>
  <div>
    <f7-tabs>
      <f7-tab :id="`tab-thong-ke-` + region" tab-active class="page-content pt-0">
        <f7-block inset class="mt-1 mb-2">
          <f7-segmented strong tag="p" v-if="region !== 'mb'">
            <f7-button v-for="(opt, idx) in filter_channel_options[region][full_datename.toLowerCase()]" :key="idx" :active="filters.channel === idx" @click.prevent="chooseFilter('channel', idx)">
              {{ opt.toUpperCase() }}
            </f7-button>
          </f7-segmented>
          <f7-segmented strong v-if="playStyle === 'mb_ngan'" tag="p">
            <f7-button :active="filters.command === 'de'" @click.prevent="chooseFilter('command', 'de')">
              Đề
            </f7-button>
            <f7-button :active="filters.command === 'de_tonghop'" @click.prevent="chooseFilter('command', 'de_tonghop')">
              Đề tổng hợp
            </f7-button>
            <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
              Lô
            </f7-button>
            <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
              3Càng
            </f7-button>
            <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
              Xiên
            </f7-button>
          </f7-segmented>
          <f7-segmented strong v-else-if="playStyle === 'mb_hanoi'" tag="p">
            <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
              Lô
            </f7-button>
            <f7-button :active="filters.command === 'de,duoi,duoi_2'" @click.prevent="chooseFilter('command', 'de,duoi,duoi_2')">
              Đề
            </f7-button>
            <f7-button :active="filters.command === 'de_tonghop'" @click.prevent="chooseFilter('command', 'de_tonghop')">
              Đề t.hợp
            </f7-button>
            <f7-button :active="filters.command === 'daunhat,giainhat'" @click.prevent="chooseFilter('command', 'daunhat,giainhat')">
              GNhất
            </f7-button>
            <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
              3Càng
            </f7-button>
            <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
              Xiên
            </f7-button>
          </f7-segmented>
          <f7-segmented strong v-else tag="p">
            <f7-button :active="filters.command === '2c'" @click.prevent="chooseFilter('command', '2c')">
              2C
            </f7-button>
            <f7-button :active="filters.command === '3c'" @click.prevent="chooseFilter('command', '3c')">
              3C
            </f7-button>
            <f7-button :active="filters.command === '4c'" @click.prevent="chooseFilter('command', '4c')">
              4C
            </f7-button>
            <f7-button :active="filters.command === 'dat'" @click.prevent="chooseFilter('command', 'dat')">
              ĐáT
            </f7-button>
            <f7-button :active="filters.command === 'dx,dx_2,dx_3,dx_4'" @click.prevent="chooseFilter('command', 'dx,dx_2,dx_3,dx_4')">
              ĐáX
            </f7-button>
          </f7-segmented>
        </f7-block>
        <f7-block strong class="mt-0 font-sm">
          <template v-if="playStyle !== 'mb_ngan'">
            <f7-row class="border-bottom-thin-solid font-bold pb-1">
              <f7-col>SỐ</f7-col>
              <f7-col>ĐÀI</f7-col>
              <f7-col>C.PHÁP</f7-col>
              <f7-col class="text-align-right">ĐIỂM</f7-col>
              <f7-col class="text-align-right">DƯ</f7-col>
              <f7-col class="text-align-right">CB</f7-col>
              <f7-col class="text-align-right">TỔNG</f7-col>
            </f7-row>
            <p v-if="data_is_loading" class="text-align-center mt-2">Đang tải dữ liệu...</p>
            <virtual-list v-else style="height: 400px; overflow-y: auto;" :data-key="'uid'" :data-sources="parsed_messages" :data-component="itemComponent"/>
          </template>
          <template v-else>
            <f7-row class="border-bottom-thin-solid font-bold pb-1">
              <f7-col>C.PHÁP</f7-col>
              <f7-col>SỐ</f7-col>
              <f7-col class="text-align-right">ĐIỂM</f7-col>
              <f7-col class="text-align-right">DƯ</f7-col>
              <f7-col class="text-align-right">CB</f7-col>
              <f7-col class="text-align-right">TỔNG</f7-col>
            </f7-row>
            <p v-if="data_is_loading" class="text-align-center mt-2">Đang tải dữ liệu...</p>
            <virtual-list v-else style="height: 400px; overflow-y: auto;" :data-key="'uid'" :data-sources="parsed_messages" :data-component="itemMbNganComponent"/>
          </template>
        </f7-block>
      </f7-tab>
      <f7-tab :id="`tab-du-chuan-` + region" class="page-content pt-0">
        <f7-list inset class="mt-1 mb-1">
          <f7-list-input
            label="DƯ CHUẨN"
            type="textarea"
            :value="over_message"
            input-id="over_message_area"
          >
          </f7-list-input>
        </f7-list>
        <f7-block class="mt-1">
          <f7-row>
            <f7-col>
              <f7-button fill color="orange" @click.prevent="breakOverPointReport">Cân bằng</f7-button>
            </f7-col>
          </f7-row>
        </f7-block>
        <template v-if="!_.isEmpty(over_messages)">
          <f7-block-title>TIN ĐÃ CÂN BẰNG</f7-block-title>
          <div class="card" v-for="(item, idx) in over_messages" :key="idx">
            <div class="card-content card-content-padding">
              <div class="pre-formatted pr-1"><strong>{{ (over_messages.length - idx) }}.</strong> {{ item.message }}
              </div>
              <div class="card-tool">
                <f7-link icon-size="18" icon-ios="f7:doc_on_doc_fill" @click.prevent="selected_over_message = item, copyToClipboard()"></f7-link>
                <br/>
                <f7-link class="mt-1" icon-size="18" icon-ios="f7:ellipsis_vertical" @click.prevent="selected_over_message = item" popover-open=".popover-message-menu"></f7-link>
              </div>
            </div>
          </div>
        </template>
      </f7-tab>
      <f7-tab :id="`tab-cau-hinh-` + region" class="page-content pt-0">
        <f7-block-title class="mt-2">CÀI ĐẶT CHUNG</f7-block-title>
        <f7-list inset inline-labels>
          <f7-list-item title="Phân loại tin">
            <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="user_info.user_configs.display_overpoint_by_format === 1" @toggle:change="toggleOverpointFormat"></f7-toggle>
          </f7-list-item>
        </f7-list>
        <f7-block inset strong class="mt-0 mb-1">
          <p>
            <label class="mr-1">
              <f7-radio name="type_input_over_config" value="all" @change="type_input_over_config = 'all'" :checked="type_input_over_config === 'all'"></f7-radio>
              Tất cả
            </label>
            <label class="mr-1">
              <f7-radio name="type_input_over_config" value="detail" @change="type_input_over_config = 'detail'" :checked="type_input_over_config === 'detail'"></f7-radio>
              Chi tiết
            </label>
          </p>
        </f7-block>
        <f7-block strong class="pt-0 mt-0" v-if="type_input_over_config === 'all' && !_.isEmpty(over_point_config.general_overpoint)">
          <f7-block-title class="margin-first pt-2 mb-0">2C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_dau"
                  @input="changeAllConfig('2c', 'over_point_dau', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_duoi"
                  @input="changeAllConfig('2c', 'over_point_duoi', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_bao"
                  @input="changeAllConfig('2c', 'over_point_bao', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="this.region === 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="8Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_tamlo"
                  @input="changeAllConfig('2c', 'over_point_tamlo', $event.target.value)">
                </f7-list-input>
              </f7-list>
              <f7-list class="mt-0 mb-0 no-border" v-else-if="this.region !== 'mb'">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_baylo"
                  @input="changeAllConfig('2c', 'over_point_baylo', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">3C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['3c'].over_point_dau"
                  @input="changeAllConfig('3c', 'over_point_dau', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['3c'].over_point_duoi"
                  @input="changeAllConfig('3c', 'over_point_duoi', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['3c'].over_point_bao"
                  @input="changeAllConfig('3c', 'over_point_bao', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['3c'].over_point_baylo"
                  @input="changeAllConfig('3c', 'over_point_baylo', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">4C</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['4c'].over_point_bao"
                  @input="changeAllConfig('4c', 'over_point_bao', $event.target.value), changeAllConfig('4c', 'over_point_baylo', $event.target.value), changeAllConfig('4c', 'over_point_duoi', $event.target.value), changeAllConfig('4c', 'over_point_tamlo', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">ĐáT</f7-block-title>
          <f7-row no-gap>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đá Thẳng"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()][first_channel]['2c'].over_point_da"
                  @input="changeAllConfig('da', 'over_point_da', $event.target.value)">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
          <f7-row no-gap v-if="region !== 'mb'">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đá Xiên"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][first_channel]['2c'].over_point_dx"
                  @input="changeAllConfig('dx', 'over_point_dx', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-row no-gap v-if="region === 'mb'">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="DX2 MB"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_2"
                  @input="changeAllConfig('dx', 'over_point_dx_2', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="DX3 MB"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_3"
                  @input="changeAllConfig('dx', 'over_point_dx_3', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="DX4 MB"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[this.region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_4"
                  @input="changeAllConfig('dx', 'over_point_dx_4', $event.target.value)">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-row class="mt-2">
            <f7-col>
              <f7-button fill color="orange" @click.prevent="updateOverPointConfig">LƯU</f7-button>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block strong class="pt-0 mt-0" v-if="type_input_over_config === 'detail' && !_.isEmpty(over_point_config.general_overpoint)">
          <f7-block-title class="margin-first pt-2 mb-0">2C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="8Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_tamlo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_tamlo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">3C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đầu"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Đuôi"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="7Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đầu`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_dau"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_dau = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Đuôi`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_duoi"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_bao = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` 7Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_baylo"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['3c'].over_point_baylo = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">4C</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['4c'].over_point_bao = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['4c'].over_point_baylo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['4c'].over_point_tamlo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['4c'].over_point_duoi = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['4c'].over_point_bao = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['4c'].over_point_baylo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['4c'].over_point_tamlo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['4c'].over_point_duoi = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['4c'].over_point_bao = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['4c'].over_point_baylo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['4c'].over_point_tamlo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['4c'].over_point_duoi = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['4c'].over_point_bao = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['4c'].over_point_baylo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['4c'].over_point_tamlo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['4c'].over_point_duoi = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase() + ` Lô`"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['4c'].over_point_bao"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['4c'].over_point_bao = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['4c'].over_point_baylo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['4c'].over_point_tamlo = $event.target.value,
                              over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['4c'].over_point_duoi = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <f7-block-title class="mt-1 mb-0">ĐáT</f7-block-title>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb'])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  label="MB"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_da = $event.target.value">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
            <f7-col class="pl-05 pr-05"></f7-col>
          </f7-row>
          <template v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb'])">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX2 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_2"
                    @input="changeAllConfig('dx', 'over_point_dx_2', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX3 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_3"
                    @input="changeAllConfig('dx', 'over_point_dx_3', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    label="DX4 MB"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()]['mb']['2c'].over_point_dx_4"
                    @input="changeAllConfig('dx', 'over_point_dx_4', $event.target.value)">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
          <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc])">
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border">
                <f7-list-input
                  outline
                  floating-label
                  :label="dc.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp2.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col class="pl-05 pr-05">
              <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3])">
                <f7-list-input
                  outline
                  floating-label
                  :label="dp3.toUpperCase()"
                  type="text"
                  class="padding-xs"
                  :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_da"
                  @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3]['2c'].over_point_da = $event.target.value">
                  >
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
          <template v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc])">
            <f7-block-title class="mt-1 mb-0">ĐáX</f7-block-title>
            <f7-row no-gap>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp2.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp2]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp2]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border" v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2])">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp.toUpperCase() + ` ` + dp2.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp + '_' + dp2]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp + '_' + dp2]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
            <f7-row no-gap v-if="!_.isUndefined(over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp3])">
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dc.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dc + '_' + dp3]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp + '_' + dp3]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05">
                <f7-list class="mt-0 mb-0 no-border">
                  <f7-list-input
                    outline
                    floating-label
                    :label="dp2.toUpperCase() + ` ` + dp3.toUpperCase()"
                    type="text"
                    class="padding-xs"
                    :value="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2 + '_' + dp3]['2c'].over_point_dx"
                    @input="over_point_config.general_overpoint[region][full_datename.toLowerCase()][dp2 + '_' + dp3]['2c'].over_point_dx = $event.target.value">
                    >
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col class="pl-05 pr-05"></f7-col>
            </f7-row>
          </template>
          <f7-row class="mt-2">
            <f7-col>
              <f7-button fill color="orange" @click.prevent="updateOverPointConfig">LƯU</f7-button>
            </f7-col>
          </f7-row>
        </f7-block>
      </f7-tab>
    </f7-tabs>
    <f7-popover class="popover-message-menu">
      <f7-list>
        <f7-list-item popover-close link="#" @click.prevent="copyToClipboard" title="Copy">
          <f7-icon slot="media" ios="f7:doc_on_doc_fill"></f7-icon>
        </f7-list-item>
        <f7-list-item popover-close link="#" @click.prevent="removeHistoryOverPoint" title="Xóa">
          <f7-icon slot="media" ios="f7:trash"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>
  </div>
</template>
<style scoped>
.btn-sorting {
  margin-top : -6px !important;
  overflow   : inherit;
  min-width  : 60px !important;
  padding    : 0 !important;
}
</style>
<script>
import moment from "moment";
import { mapState } from "vuex";
import VirtualList from 'vue-virtual-scroll-list'
import ItemRowReportOver from "../../../components/ItemRowReportOver";
import ItemRowReportOverMbNgan from "../../../components/ItemRowReportOverMbNgan";

export default {
  components: {
    VirtualList
  },
  props: {
    region: String,
    playStyle: String
  },
  data() {
    return {
      data_is_loading: true,
      regions: {
        mn: 'Miền Nam',
        mb: 'Miền Bắc',
        mt: 'Miền Trung'
      },
      filter_channel_options: {
        mb: {
          monday: {
            mb: 'mb'
          },
          tuesday: {
            mb: 'mb'
          },
          wednesday: {
            mb: 'mb'
          },
          thursday: {
            mb: 'mb'
          },
          friday: {
            mb: 'mb'
          },
          saturday: {
            mb: 'mb'
          },
          sunday: {
            mb: 'mb'
          },
        },
        mn: {
          monday: {
            dc: 'tp',
            dp: 'dt',
            dp2: 'cm'
          },
          tuesday: {
            dc: 'bt',
            dp: 'vt',
            dp2: 'bl'
          },
          wednesday: {
            dc: 'dn',
            dp: 'ct',
            dp2: 'st'
          },
          thursday: {
            dc: 'tn',
            dp: 'ag',
            dp2: 'bt'
          },
          friday: {
            dc: 'vl',
            dp: 'bd',
            dp2: 'tv'
          },
          saturday: {
            dc: 'tp',
            dp: 'la',
            dp2: 'bp',
            dp3: 'hg'
          },
          sunday: {
            dc: 'tg',
            dp: 'kg',
            dp2: 'dl'
          },
        },
        mt: {
          monday: {
            dc: 'py',
            dp: 'th'
          },
          tuesday: {
            dc: 'dl',
            dp: 'qn'
          },
          wednesday: {
            dc: 'dn',
            dp: 'kh'
          },
          thursday: {
            dc: 'bd',
            dp: 'qt',
            dp2: 'qb'
          },
          friday: {
            dc: 'gl',
            dp: 'nt'
          },
          saturday: {
            dc: 'dn',
            dp: 'qn',
            dp2: 'dno'
          },
          sunday: {
            dc: 'kt',
            dp: 'kh',
            dp2: 'th'
          },
        }
      },
      filters: {
        channel: 'dc',
        command: '2c'
      },
      type_input_over_config: 'all',
      report_data: {},
      display_overpoint_by_format: 0,
      over_point_config: {
        number_overpoint: {},
        general_overpoint: {},
      },
      itemComponent: ItemRowReportOver,
      itemMbNganComponent: ItemRowReportOverMbNgan,
      commands: [],
      over_message: '',
      selected_over_message: {}
    }
  },
  computed: {
    ...mapState(['selected_drawdate', 'user_info']),
    short_datename() {
      return moment(this.selected_drawdate).format('dd')
    },
    full_datename() {
      return moment(this.selected_drawdate).format('dddd')
    },
    parsed_messages() {
      if (this._.isEmpty(this.report_data.over_points)) {
        return [];
      }

      let msgs = [];
      this._.each(this.report_data.over_points, (msg, msg_idx) => {
        let ordering = 10;
        if (msg.command_display === 'lo') {
          ordering = 0;
        } else if (msg.command_display === 'dau' || msg.command_display === 'xcdau'){
          ordering = 1;
        } else if (msg.command_display === 'duoi' || msg.command_display === 'xcduoi') {
          ordering = 2;
        }

        msgs.push({
          uid: msg_idx,
          number: msg.number,
          channel: msg.channel,
          command: msg.command_display,
          point: msg.point,
          over_point: msg.over_point,
          executed_point: msg.executed_point,
          ordering: ordering
        });
      });

      return this._.orderBy(msgs, ['ordering', 'command', (item) => {
        return item.point + item.executed_point;
      }], ['asc', 'asc', 'desc']);
    },
    over_messages() {
      if (this._.isEmpty(this.report_data.history_combined_string)) {
        return [];
      }

      let msgs = [];
      _.each(this.report_data.history_combined_string, (item) => {
        msgs.push(item);
      });

      return msgs;
    },
    dc() {
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dc;
    },
    dp() {
      return this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp;
    },
    dp2() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp2;
    },
    dp3() {
      return (this._.isUndefined(this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3)) ? '' : this.filter_channel_options[this.region][this.full_datename.toLowerCase()].dp3;
    },
    first_channel() {
      return Object.keys(this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()])[0];
    }
  },
  methods: {
    chooseFilter(name, value) {
      this.filters[name] = value;
      this.data_is_loading = true;
      this.getOverPointReport();
    },
    getOverPointReport() {
      // this.$f7.dialog.preloader();

      this.$store.dispatch('getOverPointReport', {
        region: this.region,
        drawdate: moment(this.selected_drawdate).format('YYYY-MM-DD'),
        types: this.filters.command,
        channels: this.filters.channel === 'mb' ? 'mb' : this.filters.channel,
        play_style: this.playStyle,
        only_customer_type: [1]
      }).then((data) => {
        this.report_data = data;
        this.data_is_loading = false;

        this._.each(this.report_data.over_points, (msg) => {
          if (this.commands.indexOf(msg.command) < 0) {
            this.commands.push(msg.command);
          }
        });

        return this.$store.dispatch('getOverPointReport', {
          region: this.region,
          drawdate: moment(this.selected_drawdate).format('YYYY-MM-DD'),
          types: 'all',
          channels: 'all',
          play_style: this.playStyle,
          only_customer_type: [1]
        });
      }).then((data) => {
        // this.$f7.dialog.close();
        this.over_message = data.combined;
      }).catch(() => {
        // this.$f7.dialog.close();
        this.report_data = {};
      });
    },
    breakOverPointReport() {
      // this.$f7.dialog.preloader();

      this.$store.dispatch('getOverPointReport', {
        region: this.region,
        drawdate: moment(this.selected_drawdate).format('YYYY-MM-DD'),
        types: 'all',
        channels: 'all',
        do_break_over_point: 1,
        play_style: this.playStyle,
        only_customer_type: [1]
      }).then(() => {
        // this.$f7.dialog.close();
        this.getOverPointReport();
      }).catch(() => {
        // this.$f7.dialog.close();
        this.report_data = {};
      });
    },
    updateOverPointConfig() {
      if (this.type_input_over_config === 'all') {
        this.changeAllConfig('2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_dau);
        this.changeAllConfig('2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_duoi);
        this.changeAllConfig('2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_bao);
        this.changeAllConfig('2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_baylo);
        this.changeAllConfig('2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_tamlo);
        this.changeAllConfig('da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_da);
        this.changeAllConfig('dx', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_dx);
        if (this.region === 'mb') {
          this.changeAllConfig('dx', 'over_point_dx_2', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()]['mb']['2c'].over_point_dx_2);
          this.changeAllConfig('dx', 'over_point_dx_3', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()]['mb']['2c'].over_point_dx_3);
          this.changeAllConfig('dx', 'over_point_dx_4', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()]['mb']['2c'].over_point_dx_4);
        }
        this.changeAllConfig('3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_dau);
        this.changeAllConfig('3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_duoi);
        this.changeAllConfig('3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_bao);
        this.changeAllConfig('3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_baylo);
        this.changeAllConfig('4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_bao);
        this.changeAllConfig('4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_baylo);
        this.changeAllConfig('4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_duoi);
      }
      else if (this.type_input_over_config === 'detail') {
        if (this.region === 'mb') {
          this.changeDetailConfig('mb', '2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_dau);
          this.changeDetailConfig('mb', '2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_duoi);
          this.changeDetailConfig('mb', '2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_bao);
          this.changeDetailConfig('mb', '2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_baylo);
          this.changeDetailConfig('mb', '2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_tamlo);
          this.changeDetailConfig('mb', 'da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['2c'].over_point_da);
          this.changeDetailConfig('mb', '3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_dau);
          this.changeDetailConfig('mb', '3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_duoi);
          this.changeDetailConfig('mb', '3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_bao);
          this.changeDetailConfig('mb', '3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['3c'].over_point_baylo);
          this.changeDetailConfig('mb', '4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_bao);
          this.changeDetailConfig('mb', '4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_baylo);
          this.changeDetailConfig('mb', '4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.first_channel]['4c'].over_point_duoi);
        }
        else{
          this.changeDetailConfig('dc', '2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_dau);
          this.changeDetailConfig('dc', '2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_duoi);
          this.changeDetailConfig('dc', '2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_bao);
          this.changeDetailConfig('dc', '2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_baylo);
          this.changeDetailConfig('dc', '2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_tamlo);
          this.changeDetailConfig('dc', 'da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['2c'].over_point_da);
          this.changeDetailConfig('dc', '3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['3c'].over_point_dau);
          this.changeDetailConfig('dc', '3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['3c'].over_point_duoi);
          this.changeDetailConfig('dc', '3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['3c'].over_point_bao);
          this.changeDetailConfig('dc', '3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['3c'].over_point_baylo);
          this.changeDetailConfig('dc', '4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['4c'].over_point_bao);
          this.changeDetailConfig('dc', '4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['4c'].over_point_baylo);
          this.changeDetailConfig('dc', '4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc]['4c'].over_point_duoi);

          if (this.dp !== '') {
            this.changeDetailConfig('dp', '2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_dau);
            this.changeDetailConfig('dp', '2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_duoi);
            this.changeDetailConfig('dp', '2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_bao);
            this.changeDetailConfig('dp', '2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_baylo);
            this.changeDetailConfig('dp', '2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_tamlo);
            this.changeDetailConfig('dp', 'da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['2c'].over_point_da);
            this.changeDetailConfig('dp', '3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['3c'].over_point_dau);
            this.changeDetailConfig('dp', '3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['3c'].over_point_duoi);
            this.changeDetailConfig('dp', '3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['3c'].over_point_bao);
            this.changeDetailConfig('dp', '3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['3c'].over_point_baylo);
            this.changeDetailConfig('dp', '4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['4c'].over_point_bao);
            this.changeDetailConfig('dp', '4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['4c'].over_point_baylo);
            this.changeDetailConfig('dp', '4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp]['4c'].over_point_duoi);

            this.changeDetailConfig('dc_dp', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc + '_' + this.dp]['2c'].over_point_dx);
          }

          if (this.dp2 !== '') {
            this.changeDetailConfig('dp2', '2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_dau);
            this.changeDetailConfig('dp2', '2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_duoi);
            this.changeDetailConfig('dp2', '2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_bao);
            this.changeDetailConfig('dp2', '2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_baylo);
            this.changeDetailConfig('dp2', '2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_tamlo);
            this.changeDetailConfig('dp2', 'da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['2c'].over_point_da);
            this.changeDetailConfig('dp2', '3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['3c'].over_point_dau);
            this.changeDetailConfig('dp2', '3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['3c'].over_point_duoi);
            this.changeDetailConfig('dp2', '3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['3c'].over_point_bao);
            this.changeDetailConfig('dp2', '3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['3c'].over_point_baylo);
            this.changeDetailConfig('dp2', '4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['4c'].over_point_bao);
            this.changeDetailConfig('dp2', '4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['4c'].over_point_baylo);
            this.changeDetailConfig('dp2', '4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2]['4c'].over_point_duoi);

            this.changeDetailConfig('dc_dp2', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc + '_' + this.dp2]['2c'].over_point_dx);
            this.changeDetailConfig('dp_dp2', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp + '_' + this.dp2]['2c'].over_point_dx);
          }
          if (this.dp3 !== '') {
            this.changeDetailConfig('dp3', '2c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_dau);
            this.changeDetailConfig('dp3', '2c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_duoi);
            this.changeDetailConfig('dp3', '2c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_bao);
            this.changeDetailConfig('dp3', '2c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_baylo);
            this.changeDetailConfig('dp3', '2c', 'over_point_tamlo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_tamlo);
            this.changeDetailConfig('dp3', 'da', 'over_point_da', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['2c'].over_point_da);
            this.changeDetailConfig('dp3', '3c', 'over_point_dau', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['3c'].over_point_dau);
            this.changeDetailConfig('dp3', '3c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['3c'].over_point_duoi);
            this.changeDetailConfig('dp3', '3c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['3c'].over_point_bao);
            this.changeDetailConfig('dp3', '3c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['3c'].over_point_baylo);
            this.changeDetailConfig('dp3', '4c', 'over_point_bao', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['4c'].over_point_bao);
            this.changeDetailConfig('dp3', '4c', 'over_point_baylo', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['4c'].over_point_baylo);
            this.changeDetailConfig('dp3', '4c', 'over_point_duoi', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp3]['4c'].over_point_duoi);

            this.changeDetailConfig('dc_dp3', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dc + '_' + this.dp3]['2c'].over_point_dx);
            this.changeDetailConfig('dp_dp3', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp + '_' + this.dp3]['2c'].over_point_dx);
            this.changeDetailConfig('dp2_dp3', '2c', 'over_point_dx', this.over_point_config.general_overpoint[this.region][this.full_datename.toLowerCase()][this.dp2 + '_' + this.dp3]['2c'].over_point_dx);
          }
        }
      }

      this.$f7.dialog.preloader();

      this.$store.dispatch('updateOverPointGeneralConfig', this.over_point_config.general_overpoint).then(() => {
        this.$f7.dialog.close();
        this.changeTypeInputConfig();
        this.getOverPointReport();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    getOverPointConfig() {
      this.$store.dispatch('getOverPointConfig').then((data) => {
        this.over_point_config = data.data;
        // this.$f7.dialog.close();
      });
    },
    sortReport() {
      this.commands = this._.shuffle(this.commands);
    },
    copyToClipboard() {
      this.$copyText(this.selected_over_message.message);
    },
    removeHistoryOverPoint() {
      this.$f7.dialog.preloader();

      this.$store.dispatch('removeHistoryOverPoint', this.selected_over_message).then(() => {
        this.$f7.dialog.close();
        this.getOverPointReport();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    changeAllConfig(type, name, value) {
      if (type === '2c') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
          });
        });
      }
      else if (type === '3c') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[this.region][datename][cn]['3c'][name] = value;
          });
        });
      }
      else if (type === '4c') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[this.region][datename][cn]['4c'][name] = value;
          });
        });
      }
      else if (type === 'da') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
          });
        });
      }
      else if (type === 'dx') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
          });
        });
      }
    },
    changeDetailConfig(channel_type, type, name, value) {
      if (type === '2c' && channel_type.indexOf('_') < 0) {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (this.filter_channel_options[this.region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === '3c') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (this.filter_channel_options[this.region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[this.region][datename][cn]['3c'][name] = value;
            }
          });
        });
      }
      else if (type === '4c') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (this.filter_channel_options[this.region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[this.region][datename][cn]['4c'][name] = value;
            }
          });
        });
      }
      else if (type === 'da') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (this.filter_channel_options[this.region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === 'dx') {
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (this.filter_channel_options[this.region][datename][channel_type] === cn) {
              this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
            }
          });
        });
      }
      else if (type === '2c' && channel_type.indexOf('_') >= 0) {
        let type_cns = channel_type.split('_');
        this._.each(this.over_point_config.general_overpoint[this.region], (v2, datename) => {
          this._.each(this.over_point_config.general_overpoint[this.region][datename], (v3, cn) => {
            if (cn.indexOf('_') >= 0) {
              let cn1 = this.filter_channel_options[this.region][datename][type_cns[0]];
              let cn2 = this.filter_channel_options[this.region][datename][type_cns[1]];

              let cns = cn.split('_');
              if (cn1 === cns[0] && cn2 === cns[1]) {
                this.over_point_config.general_overpoint[this.region][datename][cn]['2c'][name] = value;
              }
            }
          });
        });
      }
    },
    changeTypeInputConfig() {
      this.user_info.user_configs.type_input_over_config = this.type_input_over_config;

      this.$store.dispatch('changeMeConfig', this.user_info.user_configs).catch((err) => {
        this.$f7.dialog.alert(err, 'LỖI!');
      })
    },
    toggleOverpointFormat(val) {
      this.user_info.user_configs.display_overpoint_by_format = val ? 1 : 0;
    },
    loadData() {
      // this.$f7.dialog.preloader();
      this.getOverPointReport();
      this.getOverPointConfig();
    }
  },
  watch: {
    selected_drawdate() {
      this.getOverPointReport();
    }
  },
  mounted() {
    this.loadData();

    this.type_input_over_config = this._.isUndefined(this.user_info.user_configs.type_input_over_config) ? 'all' : this.user_info.user_configs.type_input_over_config;
  }
}
</script>
